import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-bottom: ${props => props.theme.spacing.sp16};
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
  }
`

export const FiltersSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`
